import KeypadHome from './keypad-home';
import KeypadNewHome from './keypad-new-home';
import KeypadNewLanding from './keypad-new-landing';
import PropTypes from 'prop-types';

const Keypad = ({ navbarType = 'landing' }) => {
    if (navbarType === 'home') {
        return <KeypadHome />;
    } else if (navbarType === 'new-home') {
        return <KeypadNewHome />;
    } else if (navbarType === 'landing') {
        return <KeypadNewLanding />;
    }
    return <KeypadHome />;
};

Keypad.propTypes = {
    navbarType: PropTypes.string
};

export default Keypad;
